import iDemos from "../../assets/images/100-demos.svg";
import iHomeActive from "../../assets/images/100-home-active.svg";
import Logo from "../../assets/images/Logo-echoed.svg";
import User_profile from "../../assets/images/avatar1.png";
import organizationLogo from "../../assets/images/company_logo.png";

export const MobileHeader = () => (
  <div className="only-show-in-mobile">
    <div className="container w-100p align-center space-between" id="mobile-menu">
      <div className="mobile-logo">
        <img alt="" src={Logo} />
      </div>
      <div className="justify-content-center">
        <div className="flex mobile-top-menu">
          <div className="flex-col align-items-center B3-SemiBold fg-text-blue">
            <img alt="" src={iHomeActive} />
            <span> Workspaces </span>
          </div>
          <div className="flex-col align-items-center B3-SemiBold ">
            <img alt="" src={iDemos} />
            <span> Demos </span>
          </div>
        </div>
      </div>
      <div className="flex-end">
        <img alt="" src={organizationLogo} className="mobile-organizationLogo" />
        <img alt="" src={User_profile} className="mobile-userProfile pointer" />
      </div>
    </div>
  </div>
);
